module.exports = __webpack_public_path__ + "static/media/Tranqui.8ecf878a.apk";